import { Component } from '@angular/core';
import * as _ from 'lodash';

import { BrandService } from '../brand/brand.service';
import { Config } from '../config/env.config';


@Component({
  moduleId: module.id,
  selector: 'mobile-nav-menu',
  templateUrl: 'mobile-nav-menu.component.html',
  styleUrls: ['mobile-nav-menu.component.scss'],
})
export class MobileNavMenuComponent {

  constructor(
    private brandService: BrandService,
  ) {}

  // public
  public getBrandLogo() {
    return Config.BACKEND + '/brand-logo/' + this.brandService.getBrand();
  }
}
